import { defineStore } from "pinia";
import {
  MetaTenantAdminShowResource,
  MetaTenantWebsiteShowResource,
} from "@/modules/shared/meta/types";
import { fetchMeta } from "@/modules/shared/meta/api";
import { useShowRequestHandler } from "@/application/composables/showRequestHandler";
import { SharedModule } from "@/modules/shared/enums";

export const useMetaStore = defineStore("meta", () => {
  const { data, refresh, ...rest } = useShowRequestHandler<
    MetaTenantAdminShowResource | MetaTenantWebsiteShowResource
  >(fetchMeta, SharedModule.Meta);

  return {
    meta: data,
    fetch: refresh,
    ...rest,
  };
});
